import { useMemo } from "react";
import moment from "moment";
import { Tooltip, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

const useNow = () => useMemo(() => moment(), []);

const TimeStamp = ({ date }: { date: moment.Moment }) => {
    const now = useNow();

    const dayDiff = date.diff(now, "days");
    let timeStamp: any;

    if (dayDiff === 0) timeStamp = date.format("HH:mm");
    else if (dayDiff === -1)
        timeStamp = (
            <FormattedMessage
                id="meetingPage.room.sidebar.chat.yesterday"
                defaultMessage="Yesterday at {timeStamp}"
                values={{ timeStamp: date.format("HH:mm") }}
            />
        );
    else timeStamp = date.format("YYYY-MM-DD");

    return (
        <Tooltip title={date.format("YYYY-MM-DD dddd, HH:mm:ss")} arrow placement="top">
            <Typography sx={{ fontSize: "0.8em", opacity: 0.7 }}>{timeStamp}</Typography>
        </Tooltip>
    );
};

export default TimeStamp;
